import './App.css';
import { useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { analytics } from './lib/analytics';
import Landing from './pages/Landing';
import Pathway from './pages/Pathway';
import ActionPlan from './pages/ActionPlan';
import Barrier from './pages/Barrier';
import Technique from './pages/Technique';
import { getBCTs } from './features/bcts';
import { ModalView } from './templates/ModalView';

function App({ mode }) {
    const location = useLocation();
    const dispatch = useDispatch();
    const modalRef = useRef(null);

    useEffect(() => {
        analytics('habit-hacker', { page: location.pathname });
    }, [location]);

    useEffect(() => {
        dispatch(getBCTs());
    }, [dispatch]);
    const routes = (<Routes>
        <Route path="/" exact element={<Landing />} />
        <Route path="/pathway" exact element={<Pathway />} />
        <Route path="/pathway-:pathway" exact element={<Barrier />} />
        <Route path="/pathway-:pathway/barrier-:barrier" exact element={<Technique />} />
        <Route path="/pathway-:pathway/barrier-:barrier/bct-:bct" exact element={<ActionPlan />} />
    </Routes>);

    if(mode === 'popup') {
        return (<>
            <button className="square-button site-style-button" onClick={() => modalRef.current.openModal()}>Try our Habit Hacker</button>
            <ModalView title="Habit Hacker" ref={modalRef} blackTitleOnly>
                {routes}
            </ModalView>
        </>);
    }

    return routes;
}

export default App;
